import { render, staticRenderFns } from "./ondemand.vue?vue&type=template&id=5260630e&"
import script from "./ondemand.vue?vue&type=script&lang=js&"
export * from "./ondemand.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/app.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports